import { GetDraftPaymentItemsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { ResultConceptsType } from 'modules/payroll_bundle/lib/constants'

export const useDraftPaymentItems = (
  policyPeriodId: number,
  paymentType?: ResultConceptsType | null
) => {
  const { data, error, loading, fetchMore, networkStatus } = useQuery(
    GetDraftPaymentItemsDocument,
    {
      variables: {
        policyPeriodId: policyPeriodId,
        paymentType: paymentType,
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
    }
  )

  const paymentData = data?.payroll.draftPaymentItems ?? []

  return {
    data: paymentData,
    error,
    loading,
    fetchMore,
    networkStatus,
  }
}
